import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ADDRESS_STATUS_LABELS } from '../../enums/erp-status.enum';
import { AddressStatusERPEnum } from '@albatrosdeveloper/ave-models-package/lib/enums/addres-status-erp.enum';

@Component({
  selector: 'app-address-status-erp-badge',
  standalone: true,
  imports: [CommonModule],
  template: `
    <span [class]="badgeClasses">
      {{ statusText }}
    </span>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddressStatusErpBadgeComponent {
  @Input() status!: AddressStatusERPEnum;

  get statusText(): string {
    return this.getAddressStatusERPText();
  }

  private getAddressStatusERPText(): string {
    switch (this.status) {
      case AddressStatusERPEnum.ADDRESS_PENDING:
        return 'Pendiente envío a ERP';

      case AddressStatusERPEnum.ADDRESS_CREATED:
        return 'Creado en ERP';

      case AddressStatusERPEnum.ADDRESS_PENDING_FOR_UPDATE:
        return 'Mod. pendiente de replicar';

      case AddressStatusERPEnum.ADDRESS_FAILED_TO_SYNC:
        return 'Error al sincronizar';

      default:
        return 'Estado Desconocido';
    }
  }

  private isAddressStatusERP(): boolean {
    return Object.values(AddressStatusERPEnum).includes(this.status as AddressStatusERPEnum);
  }

  get badgeClasses(): string {
    const baseClasses =
      'px-2 py-1 rounded-full text-xs font-medium whitespace-nowrap inline-flex items-center';
    const statusClasses = this.getStatusClasses();
    return `${baseClasses} ${statusClasses}`;
  }

  private getStatusClasses(): string {
    if (this.isAddressStatusERP()) {
      return this.getAddressStatusERPClasses();
    }

    return '';
  }

  private getAddressStatusERPClasses(): string {
    switch (this.status as AddressStatusERPEnum) {
      case AddressStatusERPEnum.ADDRESS_PENDING:
        return 'bg-orange-100 text-orange-800 border border-orange-300';

      case AddressStatusERPEnum.ADDRESS_CREATED:
        return 'bg-green-100 text-green-800 border border-green-300';

      case AddressStatusERPEnum.ADDRESS_PENDING_FOR_UPDATE:
        return 'bg-yellow-100 text-yellow-800 border border-yellow-300';

      case AddressStatusERPEnum.ADDRESS_FAILED_TO_SYNC:
        return 'bg-red-100 text-red-800 border border-red-300';

      default:
        return 'bg-gray-100 text-gray-800 border border-gray-300';
    }
  }
}